import { formatarMoeda } from '../lib/formatos'
import { rotuloPrecoCaixa } from './rotuloDoPreco'
import { textoDaEmbalagemNaFicha } from './tituloDoProduto'

export interface PrecoNaMensagem {
  preco: number
  precoUnidade: number | null
  minima: number | null
}

// Texto pronto do botao Compartilhar (decisoes dela, 23/09): nome COMPLETO (e
// como sai na nota da fabrica), linha vazia nao entra, e o nome da TABELA nunca
// entra -- "VIP"/"Distribuidor" nao e coisa que o cliente deva ler.
export function mensagemDoProduto(
  produto: {
    descricao: string
    codigo: string
    unidade?: string | null
    unidades_por_embalagem?: number | null
    fabricante?: string | null
    observacoes?: string | null
  },
  preco: PrecoNaMensagem | null,
): string {
  const linhas = [`*${produto.descricao.trim()}*`]
  if (produto.codigo.trim() !== '') linhas.push(`Cód.: ${produto.codigo.trim()}`)
  const embalagem = textoDaEmbalagemNaFicha(produto)
  if (embalagem !== '—') linhas.push(`Embalagem: ${embalagem}`)
  const fabricante = (produto.fabricante ?? '').trim()
  if (fabricante !== '') linhas.push(`Fabricante: ${fabricante}`)
  // Observacoes SIM, estoque NUNCA (roteiro dela, 24/09). O estoque nem e
  // parametro desta funcao -- nao tem como vazar por engano.
  const observacoes = (produto.observacoes ?? '').trim()
  if (observacoes !== '') linhas.push(`Obs.: ${observacoes}`)
  if (preco) {
    linhas.push(`${rotuloPrecoCaixa(produto.unidade ?? '')}: ${formatarMoeda(preco.preco)}`)
    if (preco.precoUnidade != null && preco.precoUnidade > 0) {
      linhas.push(`Preço unidade: ${formatarMoeda(preco.precoUnidade)}`)
    }
    if (preco.minima != null) {
      const unidade = (produto.unidade ?? '').trim().toUpperCase() || 'UN'
      linhas.push(`Pedido mínimo: ${preco.minima} ${unidade}`)
    }
  }
  return linhas.join('\n')
}
